export function defaultThankYouUrl(checkoutUrl: string | undefined, orderHash: string | null, search: string): string {
	const params = search.replace(/^\?/, '');

	return `${checkoutUrl}/thanks/${orderHash}?withoutFrame=true${params ? `&${params}` : ''}`;
}
